/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_CostInputs */

const en_mk_sol_konsultan_cost = /** @type {(inputs: Mk_Sol_Konsultan_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thirteen seats on the Business plan: Rp 2,587,000 a month, including squads, usage analytics and audit-trail export.`)
};

const id_mk_sol_konsultan_cost = /** @type {(inputs: Mk_Sol_Konsultan_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga belas kursi paket Bisnis: Rp 2.587.000 per bulan, termasuk squad, analitik pemakaian, dan ekspor catatan audit.`)
};

/**
* | output |
* | --- |
* | "Thirteen seats on the Business plan: Rp 2,587,000 a month, including squads, usage analytics and audit-trail export." |
*
* @param {Mk_Sol_Konsultan_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_cost = /** @type {((inputs?: Mk_Sol_Konsultan_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_cost(inputs)
	return en_mk_sol_konsultan_cost(inputs)
});